import React from "react";
import { Dropdown } from "@gw/web-basic-components";
import GWIcon from "../../../icon";
import styles from "./index.module.less";
import { ROW_ICON_TITLE } from "../../config";

interface IProps {
  basicOperations: any[];
  expandOperations: any[];
  titleConfig: {
    [key: string]: string;
  };
}

export default function OperationMenu(props: IProps) {
  const { basicOperations, expandOperations, titleConfig } = props;
  const allOperations = basicOperations.concat(expandOperations);

  let operations = [];
  let moreOperations = [];

  if (allOperations.length < 4) {
    operations = operations.concat(allOperations);
  } else {
    const basicOperationsLen = basicOperations.length;
    if (basicOperationsLen === 3) {
      operations = operations.concat(basicOperations);
      moreOperations = moreOperations.concat(expandOperations);
    } else {
      operations = operations
        .concat(basicOperations)
        .concat(expandOperations.slice(0, 3 - basicOperationsLen));
      moreOperations = moreOperations.concat(
        expandOperations.slice(3 - basicOperationsLen, expandOperations.length)
      );
    }
  }

  const needMoreOperations = moreOperations.length > 0;

  const menuProps = moreOperations.map((i) => {
    const text = titleConfig?.[i.key] || ROW_ICON_TITLE?.[i.key] || "";
    return {
      key: i.key,
      label: (
        <span className={styles.itemContainer}>
          <span className={styles.icon}>{i.component}</span>
          <span className={styles.text}>{text}</span>
        </span>
      ),
    };
  });

  return (
    <span style={{ marginRight: "20px" }}>
      {operations.reverse().map((item) => {
        return React.cloneElement(item.component, {
          key: item.key,
          onClick: item.onClick || void 0,
        });
      })}
      {needMoreOperations && (
        <Dropdown
          placement="bottomRight"
          arrow={false}
          menu={{ items: menuProps }}
          overlayClassName={styles.dropdown}
        >
          <GWIcon.MoreIcon />
        </Dropdown>
      )}
    </span>
  );
}
